import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { QrCode, Camera } from "@phosphor-icons/react";
import BarcodeScanner from "../components/BarcodeScanner";

const tokenFrom = (v) => {
  let t = (v || "").trim();
  const m = t.match(/\/t\/([^/?#]+)/);
  if (m) t = m[1];
  return t.replace(/[?#].*$/, "").replace(/\/+$/, "");
};

export default function ScanPage() {
  const nav = useNavigate();
  const [val, setVal] = useState("");
  const [scanning, setScanning] = useState(false);
  const [redirecting, setRedirecting] = useState(false);

  const open = (raw) => {
    const token = tokenFrom(raw);
    if (!token) { toast.error("That doesn't look like a valid TMIC tag."); return; }
    if (redirecting) return;
    setRedirecting(true);
    nav(`/t/${token}`);
  };

  const onScan = (raw) => {
    setScanning(false);
    open(raw); // /t/{token} is the single source of truth (auth, status, revoked → handled there)
  };

  return (
    <div className="flex flex-col items-center gap-6 max-w-md mx-auto pt-6">
      <div className="h-24 w-24 bg-blue-600 rounded-2xl flex items-center justify-center">
        <QrCode size={56} weight="bold" className="text-white" />
      </div>
      <div className="text-center">
        <h1 className="font-display text-2xl font-black tracking-tight text-slate-900">Scan a Tag</h1>
        <p className="font-body text-slate-600 mt-1 text-sm">Tap an NFC tag with your phone, scan a QR code, or enter the tag code / URL below.</p>
      </div>

      <Button data-testid="scan-qr-btn" onClick={() => setScanning(true)} disabled={redirecting}
        className="h-16 w-full bg-blue-600 hover:bg-blue-700 font-bold uppercase text-lg tracking-wide">
        <Camera size={26} weight="bold" className="mr-2" />Scan QR Code
      </Button>

      <div className="w-full flex flex-col gap-3">
        <div className="flex items-center gap-2 text-xs text-slate-400"><div className="h-px bg-slate-200 flex-1" />or enter manually<div className="h-px bg-slate-200 flex-1" /></div>
        <Input data-testid="scan-input" placeholder="Paste tag URL or token" value={val} onChange={(e) => setVal(e.target.value)} className="h-14 text-base border-2" />
        <Button data-testid="scan-go" onClick={() => open(val)} disabled={!val.trim() || redirecting} className="h-14 bg-slate-900 hover:bg-slate-800 font-bold uppercase text-lg">Open</Button>
      </div>

      {scanning && (
        <BarcodeScanner title="Scan TMIC QR code" preferRear
          onDetected={onScan} onClose={() => setScanning(false)} />
      )}
    </div>
  );
}
